import { useState } from "react"
import { useQuery } from "react-query"
import { getCourse } from "~/actions/courses"
import NewActionButton from "~/components/Common/NewActionButton"
import NewSort from "~/components/Common/NewSort"
import AddTranslationDialog from "~/components/Translations/AddTranslationDialog"
import TranslationsList from "~/components/Translations/TranslationsList"
import { COURSE_OPTIONS } from "~/constants/translations"
import useSortTranslations from "~/hooks/useSortTranslations"
import Page from "~/pages/Page"
import Router from "~/router"

const Translations = ({ routes = [], ...rest }) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [translation, setTranslation] = useState({})
  const courseId = Number(rest?.match?.params?.course_id)

  const { data: course } = useQuery(
    ["course", courseId],
    () => getCourse(courseId),
    { cacheTime: 0 },
  )

  const { sortedTranslations, sort, setSort } = useSortTranslations(course)

  const updateTranslation = (translation) => {
    setTranslation(translation)
    setOpenDialog(true)
  }

  const closeDialog = () => {
    setTranslation({})
    setOpenDialog(false)
  }

  return (
    <Page>
      <div className="p-4">
        <div className="flex justify-between items-center">
          <NewActionButton
            title="new translation"
            action={() => setOpenDialog(true)}
            haveIcon={true}
          />
          <NewSort
            options={COURSE_OPTIONS}
            sort={sort}
            setSort={setSort}
            data={course?.translations ?? []}
          />
        </div>
        <TranslationsList
          translations={sortedTranslations}
          updateTranslation={updateTranslation}
          typeData={{
            type_id: courseId,
            type: "courses",
          }}
          options={COURSE_OPTIONS}
        />
        <AddTranslationDialog
          open={openDialog}
          closeDialog={closeDialog}
          translation={translation}
          typeData={{
            type_id: courseId,
            type: "courses",
          }}
          translations={sortedTranslations}
        />
      </div>
      <Router routes={routes} {...rest} />
    </Page>
  )
}

export default Translations
